import React from 'react';
import TweenOne from 'rc-tween-one';
import './../../assets/styles/OthersTitle.css'


const OthersTitle = props => {
    const TITLE_LINE_1 = `VEJA TAMBÉM`;
    const TITLE_LINE_2 = `OUTROS TITULOS`;
    const isSurprise = (props.appState === 'firsttimevisit')
        ? true
        : false
    ;
    return (
        <TweenOne id="others_title" className={`others_title_container ${isSurprise ? 'hide' : ''}`} paused={isSurprise} animation={{ opacity: 1 }}>
            <p>{TITLE_LINE_1}</p>
            <p>{TITLE_LINE_2}</p>
        </TweenOne>
    );
}

export default OthersTitle;